import { ContainerModule } from 'inversify';
import CartService from '../features/cart/data/service/CartService';
import CartRepository from '../features/cart/data/CartRepository';
import { CartServiceInterface } from '../features/cart/data/service/CartService.types';
import { CartRepositoryInterface } from '../features/cart/domain/CartRepositoryInterface';

export const cartBindings = new ContainerModule((bind) => {
  bind<CartServiceInterface>(CartService).to(CartService);
  bind<CartRepositoryInterface>(CartRepository).to(CartRepository);
});
